import {Member} from "../../src/interfaces/interfaces";

const SAmembers : Member[] = [
    { name: 'Frydrychová Eliška' },
    { name: 'Hrdličková Aneta' },
    { name: 'Mikešová Alexandra' },
    { name: 'Němcová Melánie' },
    { name: 'Novosadová Evelin' },
    { name: 'Pecháčková Sára' },
    { name: 'Sochorová Zuzana' },
    { name: 'Šmakalová Iveta' },
    { name: 'Tesařová Gabriela' },
    { name: 'Vejrostová Laura' },
]

export default SAmembers
